import { Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

interface Props {
  children: React.ReactNode;
  to: string;
}

export function LinkButton(props: Props) {
  const { children, to } = props;

  return (
    <SambaAutoLink
      to={to}
      variant="solidSecondary"
      css={{
        bg: 'background.transparent',
        color: 'primitives.white.100',
        display: 'flex',
        mx: 'space.150',
        my: 'space.200',
        boxShadow: 'none',
        borderStyle: 'solid',
        borderWidth: 'thin',
        borderColor: 'border.onPrimary',
        _hover: {
          background: 'primitives.white.100alpha15',
        },
      }}
    >
      <Text variant="text50">{children}</Text>
    </SambaAutoLink>
  );
}

LinkButton.displayName = 'Nav.LinkButton';
